<template>
	<div>
		<navigationbar v-if="show"></navigationbar>
		<div class="fadeInRight">
			<div class="content">
				<div>
					<div class="product">
						<div class="collection" v-if="collection" @click="collection2()">
							<img src="../assets/img/shape2.png">
							<span>添加收藏</span>
						</div>
						<div class="collection" v-else @click="collection2()">
							<img src="../assets/img/shape1.png">
							<span>已收藏</span>
						</div>
						<div class="hd">
							<img :src="imageUrl" alt>
						</div>
						<div class="bd">
							<div>
								<span class="title">{{ model }}</span>
								<span class="series"></span>
								<span class="sub">{{ msname }}</span>
							</div>
						</div>
						<div class="icons">
							<img v-for="(img, index) in platimgurl" :key="index" :src="img.imageUrl" alt>
						</div>
					</div>

					<div class="listhr"></div>
					<div
						class="list"
						v-for="(goods, index) in oftenGoods.instructions"
						:key="index"
						@click="showDetail5(index)"
					>
						<div class="quick" :class="{expand:expand}">
							<div class="item">
								<span>{{ goods.catalogContentName }}</span>
								
								<img src="../assets/img/arrow_right.png" class="arrow" v-if="goods.children==null">
								<img src="../assets/img/plus.png" class="plus" v-else v-show="minus1">
								<img
									src="../assets/img/minus.png"
									class="minus"
									v-if="goods.children!=null"
									v-show="minus2"
								>
							</div>
							<div class="cells">
								<div class="cell" v-for="(ep,indexChild) in goods.children" :key="indexChild" @click="send2(indexChild)">
									<span class="ep">{{ ep.catalogContentName }}</span>
									<img src="../assets/img/Group14.png" class="video">
									<img src="../assets/img/arrow_right.png" class="arrow">
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import getGoodsId from "@/components/common/getGoodsId";
import navigationbar from "@/components/navigationbar";
import axios from "axios";
import apiConfig from "../api";
export default {
	name: "goodsdetail",
	data() {
		return {
			imageUrl: "",
			model: "",
			msname: "",
			platforms: "",
			platimgurl: "",
			flag: false,
			plus: false,
			oftenGoods: { msCategory: {} },
			oftenGoods2: { platforms: {} },
			datas: "",
			oftenGoods3: [],
			collection: "",
			collectiondata: [],
			id: "",
			children: "",
			hidden: true,
			minus1: true,
			minus2: false,
			minus: "",
			expand: false,
			vid: "",
			video: "",
			openid: "",
			msg: "",
			desc: "",
			title: "",
			from: "",
			show: true
		};
	},
	created() {
		this.from = getGoodsId("from");
		axios
			.get(apiConfig.serverAddress + "wechat/model?model=MY-HT5087PG")
			.then(response => {
				this.oftenGoods = response.data;
				this.datas = this.oftenGoods.instructions;
				this.imageUrl = this.oftenGoods.imageUrl;
				this.model = this.oftenGoods.model;
				this.msname = this.oftenGoods.msCategory.name;
				this.platimgurl = this.oftenGoods.platforms;
				this.oftenGoods2 = response.data;
				this.collection = this.oftenGoods.isCollection;
			})
			.catch(() => {
				console.log("网络错误，不能访问");
			});
	},
	mounted() {
		const browser = {
			versions: (function() {
				const u = navigator.userAgent;
				return {
					trident: u.indexOf("Trident") > -1, //IE内核
					presto: u.indexOf("Presto") > -1, //opera内核
					webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
					gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") === -1, //火狐内核
					mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
					ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
					android: u.indexOf("Android") > -1 || u.indexOf("Adr") > -1, //android终端
					iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
					iPad: u.indexOf("iPad") > -1, //是否iPad
					webApp: u.indexOf("Safari") === -1, //是否web应该程序，没有头部与底部
					weixin: u.indexOf("MicroMessenger") > -1, //是否微信 （2015-01-22新增）
					hongmeng: u.indexOf("MideaOpenHormanyNext") > -1,
					qq: u.match(/\sQQ/i) === " qq" //是否QQ
				};
			})(),
			language: (navigator.browserLanguage || navigator.language).toLowerCase()
		};
		
		if (browser.versions.hongmeng) {
      this.show = true;
    }
		if (browser.versions.android) {
			this.show = true;
		}
		if (browser.versions.ios && this.from !== "control") {
			this.show = false;
		}
		if (browser.versions.iPad && this.from !== "control") {
			this.show = false;
		}
		if (browser.versions.iPhone && this.from !== "control") {
			this.show = false;
		}
		const program = getGoodsId("program");
    if (this.from === "weex" || program === 'miniColmo') {
      this.show = false;
    }
	},
	components: {
		navigationbar
	},
	methods: {
		collection2: function() {
			this.collection = !this.collection;
			if (this.collection === false) {
				const url =
					apiConfig.serverAddress +
					"wechat/collection?productId=" +
					this.id +
					"&openId=undefined";
				axios
					.get(url)
					.then(response => {
						this.oftenGoods3 = response.data;
					})
					.catch(() => {
						console.log("网络错误，不能访问");
					});
			} else {
				const url =
					apiConfig.serverAddress +
					"wechat/cancelCollection?productId=" +
					this.id +
					"&openId=undefined";
				axios
					.get(url)
					.then(response => {
						this.oftenGoods3 = response.data;
					})
					.catch(() => {
						console.log("网络错误，不能访问");
					});
			}
		},
		showDetail5: function(i) {
			this.vid = i;
			const insid = this.datas[i].id;
			if ((this.children = this.oftenGoods.instructions[i].children === null)) {
				if (this.oftenGoods.instructions[i].videos === null) {
					this.$router.push(
						`/detaillist/detail/goodsdetail/instruction/${insid}`
					);
					this.$route.params.id = insid;
				} else {
					const j = this.oftenGoods.instructions[i].id;
					this.$router.push(`/detaillist/detail/goodsdetail/video/${j}`);
					this.$route.params.id = this.oftenGoods.instructions[i].id;
				}
			} else if (
				(this.children = this.oftenGoods.instructions[i].children.length > 0)
			) {
				this.expand = !this.expand;
			}
			if (this.minus1 === true) {
				this.minus1 = false;
				this.minus2 = true;
			} else {
				this.minus1 = true;
				this.minus2 = false;
			}
		},
		send2(i) {
			const t = this.datas[this.vid].children[i].id;
			this.$router.push(`/detaillist/detail/goodsdetail/video/${t}`);
			this.$route.params.id = this.datas[this.vid].children[i].id;
		}
	}
};
</script>


<style scoped>
.content {
	margin-top: 100px;
}
.product {
	display: flex;
	align-items: center;
	border: 1px solid #e8e8e8;
	background: #ffffff;
	position: relative;
	height: 350px;
	overflow: hidden;
}
.ep {
	font-size: 32px;
	font-weight: 600;
}

.hd {
	margin: 0 60px 0 90px;
	width: 170px;
	height: 170px;
	overflow: hidden;
}

.hd img {
	width: 170px;
	height: 170px;
}

.bd {
	flex: 1;
}
.collection {
	position: absolute;
	right: 30px;
	top: 30px;
	display: flex;
	justify-content: flex-end;
}

.collection img {
	width: 50px;
	height: 40px;
}

.collection span {
	margin-left: 10px;
	color: #bcbcbc;
	font-size: 24px;
}

.bd .title {
	margin-bottom: 20px;
	margin-right: 90px;
	display: block;
	font-size: 36px;
	color: #333333;
	font-weight: bold;
	word-break: break-all;
}

.bd .sub {
	margin-top: 8px;
	display: block;
	font-size: 28px;
	color: #7c7c7c;
	line-height: 1;
}

.bd .series {
	margin-right: 90px;
	display: block;
	font-weight: bold;
	font-size: 20px;
	color: #333333;
	line-height: 1;
}

.icons {
	position: absolute;
	right: 100px;
	bottom: 61px;
	display: flex;
}
.icons img {
	width: 60px;
	height: 60px;
}
.listhr {
	height: 20px;
}

.list {
	padding: 1px 20px;
}

.item {
	display: flex;
	align-items: center;
	min-height: 152px;
	padding: 0 62px;
	border-radius: 10px;
	background: #ffffff;
	margin-bottom: 8px;
}

.item span {
	flex: 1;
	font-size: 32px;
	color: #000000;
}

.item .icon {
	margin-right: 40px;
	width: 46px;
	height: 46px;
}

.item .arrow {
	width: 12px;
	height: 24px;
}

.item .plus {
	width: 26px;
	height: 26px;
}

.item .minus {
	width: 26px;
	height: 26px;
}

.item .video {
	margin-right: 40px;
	width: 44px;
	height: 44px;
}

.quick {
	margin-bottom: 6px;
	border: 1px solid #e0e0e0;
	border-radius: 10px;
	background: #ffffff;
}

.quick .item {
	border: none;
}

.quick .cells {
	padding-left: 54px;
	padding-right: 16px;
	display: none;
}

.expand .cells {
	display: block;
}

.quick .cell {
	display: flex;
	justify-content: space-between;
	align-items: center;
	min-height: 138px;
	padding: 0 44px;
	border: 1px solid #e0e0e0;
	border-radius: 10px;
	background: #f8f8f8;
	margin-bottom: 18px;
}

.cell span {
	flex: 1;
}
.cell .arrow {
	width: 12px;
	height: 24px;
}
.cell .video {
	margin-right: 40px;
	width: 44px;
	height: 44px;
}
.video {
	margin-right: 40px;
	width: 44px;
	height: 44px;
}
</style>



// WEBPACK FOOTER //
// src/components/goodsdetail.vue